<template>
  <div id="municipio">
    <div
      v-if="loadingPage || loadingData"
      class="d-flex justify-content-center align-items-center"
      style="height: 50vh"
    >
      <b-spinner large variant="primary"></b-spinner>
    </div>

    <div v-else>
      <div class="row mt-3">
        <div class="col-lg-4">
          <vue-select
            name="periodo"
            v-model="periodo"
            class="select-periodo"
            :clearable="false"
            :options="optionsPeriodo"
            label="label"
            placeholder="Período"
            @input="onChangePeriodo"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
      <dashboard-equipes
        :dadosDashboard="dadosDashboardEquipes"
        :dadosEscore="dadosEscore"
        :periodo="periodo"
      ></dashboard-equipes>
      <dashboard-microareas
        :dadosDashboard="dadosDashboardMicroareas"
        :dadosEscore="dadosEscore"
        :periodo="periodo"
      ></dashboard-microareas>
    </div>
  </div>
</template>

<script>
import DashboardEquipes from './components/DashboardEquipes'
import DashboardMicroareas from './components/DashboardMicroareas'

export default {
  props: {
    loadingPage: {
      type: Boolean,
      default: false,
    },
    cadastros: {
      type: Array,
      default: () => {},
    },
    dadosEscore: {
      type: Array,
      default: () => {},
    },
  },
  components: {
    DashboardEquipes,
    DashboardMicroareas,
  },
  data() {
    return {
      dadosDashboardEquipes: [],
      dadosDashboardMicroareas: [],
      periodo: null,
      optionsPeriodo: [],
      loadingData: false,
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
        this.periodo = this.optionsPeriodo[0]
        this.onChangePeriodo(this.periodo)
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    async onChangePeriodo(item) {
      let periodo = item.value.replace('/', '-')
      try {
        this.loadingData = true
        let response = await this.$api.get(
          `/app/v2/diagnostico-situacional/classificacao-das-equipes/${this.$store.state.cod_ibge}/${periodo}`
        )
        if (response) {
          this.dadosDashboardEquipes = response.data
        }

        let response2 = await this.$api.get(
          `/app/v2/diagnostico-situacional/classificacao-das-microareas/${this.$store.state.cod_ibge}/${periodo}`
        )
        if (response2) {
          this.dadosDashboardMicroareas = response2.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingData = false
      }
    },
  },
}
</script>

<style lang="scss"></style>
